<template>
    <div class="flex items-center gap-3 w-full" :dusk="dusk">
        <input
            :id="id"
            v-model.number="modelValue"
            type="range"
            :min="field?.min ?? 0"
            :max="field?.max ?? 100"
            :step="field?.step ?? 1"
            :disabled="disabled"
            class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
            :class="{ 'opacity-50 cursor-not-allowed': disabled }"
        />
        <span class="text-sm text-gray-600 whitespace-nowrap min-w-[3rem] text-right">
            {{ modelValue ?? field?.min ?? 0 }}{{ field?.suffix ?? '%' }}
        </span>
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import type { FieldComponent } from '@src/Common/Components/types';

const modelValue = defineModel({ type: [Number, String] });

const props = withDefaults(defineProps<FieldComponent>(), {
    disabled: false,
    id: null,
});

onMounted(() => {
    if (modelValue.value === undefined || modelValue.value === null) {
        modelValue.value = props.field?.max ?? 100;
    } else if (typeof modelValue.value === 'string') {
        modelValue.value = Number(modelValue.value);
    }
});
</script>
